module.exports = __webpack_public_path__ + "img/logo-clr.e706b1db.png";